import type { IEmployee } from "@medoma/models/shifts";
import type { IShiftWithContents } from "@medoma/models/shiftWithContents";

interface CategorizedShifts {
  currentUsersShifts: IShiftWithContents[];
  staffedShifts: IShiftWithContents[];
  notStaffedShifts: IShiftWithContents[];
}

/**
 * Categorizes relevant shifts into three groups:
 * 1. Current user's shifts (shown first with special styling)
 * 2. Other staffed shifts
 * 3. Unstaffed shifts
 */
export function categorizeShifts(
  relevantShifts: IShiftWithContents[],
  currentUser: Pick<IEmployee, "id"> | null | undefined,
): CategorizedShifts {
  const currentUsersShifts = currentUser
    ? relevantShifts.filter(({ shift: { employee } }) => {
        if (employee && employee.id === currentUser.id) {
          return true;
        }
        return false;
      })
    : [];

  const relevantShiftsWithoutCurrentUsersShift =
    currentUsersShifts.length === 0
      ? relevantShifts
      : relevantShifts.filter(({ shift: { employee } }) => {
          if (currentUser && employee && employee.id === currentUser.id) {
            return false;
          }
          return true;
        });

  const staffedShifts = relevantShiftsWithoutCurrentUsersShift.filter(
    ({ shift: { employee } }) => employee !== null && employee !== undefined,
  );

  const notStaffedShifts = relevantShiftsWithoutCurrentUsersShift.filter(
    ({ shift: { employee } }) => employee === null || employee === undefined,
  );

  return {
    currentUsersShifts,
    staffedShifts,
    notStaffedShifts,
  };
}
